import React from 'react'

export default function PageHeading(props) {
  return (
    <div className='d-flex flex-column flex-md-row justify-content-between pageheading' >
        <span style={{color: props.color, fontSize:props.fontSize}}>{props.pagename}</span>
    </div>
  )
}
